window.bundleDataV = {
"Valentina-girl": {
displayName: "Valentina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Valentina Personalized Coloring Experience",
variantId: "49666621571309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Valentina_final_cover.png?v=1773592233",
price: "$14.99",
preorder: true
},
{
title: "Valentina Unicorn Holographic Sticker",
variantId: "49933754138861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Valentina_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Valentina Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Valeria-girl": {
displayName: "Valeria",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Valeria Personalized Coloring Experience",
variantId: "49666559607021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Valeria_final_cover.png?v=1773592234",
price: "$14.99",
preorder: true
},
{
title: "Valeria Unicorn Holographic Sticker",
variantId: "49933754237165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Valeria_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Valeria Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Valerie-girl": {
displayName: "Valerie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Valerie Personalized Coloring Experience",
variantId: "49666538635501",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Valerie_final_cover.png?v=1773592233",
price: "$14.99",
preorder: true
},
{
title: "Valerie Unicorn Holographic Sticker",
variantId: "49933754466541",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Valerie_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Valerie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Victor-boy": {
displayName: "Victor",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Victor Personalized Coloring Experience",
variantId: "49414805717229",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Victor.png?v=1772144942",
price: "$14.99",
preorder: true
},
{
title: "Victor Dragon Holographic Sticker",
variantId: "49933760266477",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Victor_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Victor Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Victoria-girl": {
displayName: "Victoria",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Victoria Personalized Coloring Experience",
variantId: "49279574442221",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Victoria_final_cover.png?v=1773766534",
price: "$14.99",
preorder: true
},
{
title: "Victoria Unicorn Holographic Sticker",
variantId: "49933773111533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Victoria_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Victoria Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Vincent-boy": {
displayName: "Vincent",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Vincent Personalized Coloring Experience",
variantId: "49414806536429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vincent.png?v=1772144992",
price: "$14.99",
preorder: true
},
{
title: "Vincent Dragon Holographic Sticker",
variantId: "49933760233709",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vincent_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Vincent Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Violet-girl": {
displayName: "Violet",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Violet Personalized Coloring Experience",
variantId: "49279574507757",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Violet_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Violet Unicorn Holographic Sticker",
variantId: "49933773078765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Violet_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Violet Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Vivian-girl": {
displayName: "Vivian",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Vivian Personalized Coloring Experience",
variantId: "49279574573293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vivian_final_cover.png?v=1773766534",
price: "$14.99",
preorder: true
},
{
title: "Vivian Unicorn Holographic Sticker",
variantId: "49933773045997",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vivian_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Vivian Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Vera-girl": {
displayName: "Vera",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Vera Personalized Coloring Experience",
variantId: "50594939699437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Verafinalcover.png?v=1788157876",
price: "$14.99",
preorder: true
},
{
title: "Vera Unicorn Holographic Sticker",
variantId: "50604075745517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vera_holographic_sticker.png?v=1788224571",
price: "$4.99",
preorder: false
},
{
title: "Vera Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Vivienne-girl": {
displayName: "Vivienne",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Vivienne Personalized Coloring Experience",
variantId: "50643930546413",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vivienne_final_cover.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Vivienne Unicorn Holographic Sticker",
variantId: "50643944210669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Vivienne_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Vivienne Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 




};